export function calcAvarageRadiant(data){
  return data.map(item => {
    let heroName = Object.keys(item)[0]
  
    if(item[heroName] === null) {
      return ['unknown', null]
    }

    const advantageAgainstDireHeroes = Object.values(item[heroName]).filter(item => item !== null)

    let sum = advantageAgainstDireHeroes.reduce((prev,curr) => {
      return prev += curr
    },0)

    let avarage = (sum / advantageAgainstDireHeroes.length).toFixed(2)

    return [heroName,avarage]
  })
}

export function calcAvarageDire(data){
  const serialize = data.reduce((prev,curr) => {
    const key = Object.keys(curr)[0]
    const values = curr[key]
    
    return {
      ...prev,
      [key]: values, 
    }
  },{})


  const radiantHeroes = Object.keys(serialize);
  const radiantHeroesCount = data.reduce((prev,curr) => { return prev += Object.values(curr)[0] === null ? 0 : 1 }, 0)
 
  const calcData = radiantHeroes.reduce((prev,radiantHeroName) => {
    const counterweights = serialize[radiantHeroName];

    if(counterweights === null) {
      return prev
    }

    for(let [direHeroName,advantage] of Object.entries(counterweights)) {
      if(advantage === null) {
        prev[direHeroName] = null;
        continue;
      }

      if(!prev[direHeroName]) {
        prev[direHeroName] = 0;
      }

      prev[direHeroName] = prev[direHeroName] + advantage
    }

    return prev;
  }, {})

  const beautyData = Object.entries(calcData).reduce((prev,curr) => {
    //Минус перед числом выполняет инверсию из -1 в 1 и 1 в -1
    const heroName = curr[0];
    const heroAdvantage = curr[1];
    if(heroAdvantage === null) {
      prev.push(['unknown', null])
    } else {
      prev.push([heroName, (-heroAdvantage / radiantHeroesCount).toFixed(2)])
    }
    return prev;
  }, [])

  return beautyData
}